import { MessagePlugin } from "tdesign-vue-next";
import axios from "axios";
import store from "@/store"; // 假设你的 store 文件路径为 "@/store"
import Cookies from "js-cookie";
// 获取路由菜单
import router from "../router/index";
import { flag } from "@/utils/handleUrl.js";
axios.defaults.withCredentials = true;

const service = axios.create({
  // baseURL: window.g.BASE_API,
  baseURL:
    process.env.NODE_ENV === "production" ? `${window.g.BASE_API}` : "/api",
  timeout: 1000000, // 请求超时时间
});
var getToken = Cookies.get("tokenValue");
var schoolId = Cookies.get("schoolId");

// 创建 store.subscribe() 监听器来监听 schoolId 的变化
store.subscribe((mutation, state) => {
  // 如果 schoolId 发生变化，则更新变量的值
  if (mutation.type === "setSchoolId") {
    schoolId = state.schoolId;
  }
});

service.interceptors.request // request拦截器
  .use(
    (config) => {
      if (getToken) {
        config.headers["Authorization"] = getToken;
      }
      if (schoolId) {
        config.headers["tenant-id"] = schoolId;
      }
      config.headers["language"] = window.g.LANG;
      return config;
    },
    (error) => {
      hideLoading();
      Promise.reject(error);
    }
  );

// 全局变量，用于控制定时器状态
let errorTimer = null;
// respone拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.code == 401) {
      if (!errorTimer) {
        // 如果定时器不存在，则可以执行错误提示
        // MessagePlugin.error(response.data.msg);

        // 开启定时器，2秒后重置定时器为null，可以再次触发错误提示
        errorTimer = setTimeout(() => {
          errorTimer = null;
        }, 2000);
      }
      const cookies = document.cookie.split("; ");

      cookies.forEach((cookie) => {
        const [name] = cookie.split("="); // 提取 Cookie 名称
        // 移除每个 Cookie
        Cookies.remove(name, { domain: window.g.localName });
      });

      window.location.href = window.location.origin + "/login";
      // router.replace({
      //   path: "/login",
      // });
      if (flag()) {
        // 移动端
        // const query = window.location.search.substring(1);
        // const queryArr = query.split("_"); // url参数：学校id 业务id 业务类型
        // window.location.href = window.location.origin + "/Wenxiang_H5Login" + "?schoolId=" + queryArr[0];
      } else {
        // pc端
        // window.location.href = window.location.origin + "/login";
      }
    } else if (response.data.code === 444 || response.data.code === 1001) {
      if (!errorTimer) {
        // 如果定时器不存在，则可以执行错误提示
        MessagePlugin.error(response.data.msg);

        // 开启定时器，2秒后重置定时器为null，可以再次触发错误提示
        errorTimer = setTimeout(() => {
          errorTimer = null;
        }, 2000);
      }
    }
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
